import moment from 'moment';

import { GameTypeEnum, queryBuilder } from '@lbs/swarm-client';

export const getGameDataRequest = (gameIds = []) => queryBuilder()
  .useSource('betting')
  .selectMarket(['id', 'name', 'type', 'col_count', 'display_key', 'market_type', 'order', 'extra_info'])
  .selectEvent([
    'id',
    'name',
    'type',
    'type_1',
    'base',
    'price',
    'order',
    'nonrunner',
    'extra_info',
    'original_order',
    'ew_allowed',
    'sp_enabled',
  ])
  .selectGame([
    'id',
    'region_alias',
    'start_ts',
    'type',
    'game_info',
    'is_blocked',
    'info',
    'is_live',
    'game_number',
    '#competition:id',
    '#competition:name',
    '#region:id',
  ])
  .whereGame('id')
  .in(gameIds)
  .getParams();

export const getFutureAndSpecialRacingList = (sportId) => queryBuilder()
  .useSource('betting')
  .selectRegion(['id', 'name', 'alias', 'order'])
  .selectCompetition(['id', 'name', 'order'])
  .selectGame(['id', 'start_ts', 'team1_name'])
  .whereGame('start_ts')
  .in({})
  .whereSport('id')
  .is(sportId)
  .getParams();

export const getNextRacingsList = (sportId) => queryBuilder()
  .useSource('betting')
  .selectGame(['start_ts', 'id', 'team1_name', '#region:id', '#region:alias', '#competition:id'])
  .selectEvent(['ew_allowed'])
  .whereSport('id')
  .is(+sportId)
  .whereGame('type')
  .in([GameTypeEnum.Prematch, GameTypeEnum.FutureLive])
  .getParams();

export const getRegiongsList = (sportId) => queryBuilder()
  .useSource('betting')

  .selectRegion(['id', 'name', 'alias', 'order'])
  .selectGame('@count')
  .whereSport('id')
  .is(+sportId)
  .getParams();

export const getRacingsList = (sportId, dateFilter) => queryBuilder()
  .useSource('betting')
  .selectRegion(['id', 'name', 'alias', 'order'])
  .selectCompetition(['id', 'name', 'order'])
  .selectGame(['id', 'start_ts'])
  .whereGame('start_ts')
  .lessThan(moment.unix(dateFilter).endOf('day').unix())
  .whereGame('start_ts')
  .greatherThan(moment.unix(dateFilter).startOf('day').unix())
  .whereSport('id')
  .is(sportId)
  .getParams();

export const getCompetitionGamesById = (compId, dateFilter) => queryBuilder()
  .useSource('betting')
  .selectGame(['id', 'start_ts', '#competition:name'])
  .whereCompetition('id')
  .is(compId)
  .whereGame('start_ts')
  .greatherThan(moment.unix(dateFilter).startOf('day').unix())
  .whereGame('start_ts')
  .lessThan(moment.unix(dateFilter).endOf('day').unix())
  .getParams();

export const getGameDetails = (gameId, compId, regionAlias) => {
  const builder = queryBuilder()
    .useSource('betting')
    .selectGame([
      'id',
      'start_ts',
      'game_info',
      'is_blocked',
      'info',
      'is_live',
      'game_number',
      '#region:alias',
    ])
    .selectMarket(['id', 'name', 'type', 'col_count', 'display_key', 'market_type', 'order', 'extra_info'])
    .selectEvent([
      'id',
      'name',
      'type',
      'type_1',
      'base',
      'price',
      'order',
      'nonrunner',
      'extra_info',
      'original_order',
      'ew_allowed',
      'sp_enabled',
    ]);

  if (gameId) builder.whereGame('id').is(gameId);
  else {
    builder.whereRegion('alias').is(regionAlias).whereCompetition('id').is(compId);
  }

  return builder.getParams();
};

export const getFutureSpecialGameDetails = (gameId) => {
  const builder = queryBuilder()
    .useSource('betting')
    .selectGame(['id', 'start_ts', 'game_info', 'game_number', 'is_blocked', 'info', 'is_live', 'team1_name', 'team2_name', '#region:alias', '#competition:name'])
    .selectMarket(['id', 'name', 'type', 'cashout', 'col_count', 'display_key', 'market_type', 'name_template', 'order', 'point_sequence', 'sequence', 'display_color', 'group_id', 'group_name', 'extra_info', 'express_id'])
    .selectEvent(['id', 'name', 'type', 'type_1', 'base', 'price', 'order', 'nonrunner', 'extra_info', 'original_order', 'ew_allowed', 'sp_enabled'])
    .whereGame('id')
    .is(gameId);

  return builder.getParams();
};
